var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.51193 1C12.6445 1.00385 16.0061 4.38091 15.9984 8.5204C15.9907 12.6599 12.6098 16.01 8.47034 16C4.3578 15.9892 1 12.6175 1 8.49806C1.00388 6.50824 1.79699 4.60123 3.20531 3.19551C4.61363 1.7898 6.5221 1.0002 8.51193 1ZM15.2776 8.74297C15.397 5.12332 12.6237 1.88874 8.75452 1.72624C7.86576 1.6916 6.97889 1.83255 6.14465 2.14102C5.31042 2.44948 4.54519 2.91941 3.89276 3.52392C3.24033 4.12843 2.71349 4.85565 2.3424 5.66397C1.9713 6.47229 1.76323 7.34586 1.73009 8.23467C1.69373 9.12666 1.83427 10.017 2.14362 10.8544C2.45298 11.6919 2.92502 12.4598 3.53254 13.1139C4.14007 13.768 4.87105 14.2954 5.68336 14.6657C6.49567 15.036 7.37324 15.2419 8.26548 15.2714C11.8828 15.4131 15.0974 12.6191 15.2776 8.74297Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04748 7.44435C8.04748 6.64957 8.05287 5.85479 8.04748 5.05692C8.04748 4.78738 8.08522 4.52861 8.39789 4.52399C8.71057 4.51937 8.76217 4.76966 8.7614 5.04383C8.75447 6.45395 8.7691 7.86408 8.74985 9.2742C8.74522 9.5915 8.84842 9.65311 9.13877 9.64695C10.0098 9.62923 10.8816 9.64695 11.7526 9.63847C12.0122 9.63847 12.2324 9.68622 12.2324 9.99505C12.2324 10.3039 12.0114 10.3524 11.7526 10.3509C10.6744 10.3462 9.59623 10.3432 8.52266 10.3509C8.17455 10.3509 8.04286 10.2022 8.04748 9.86181C8.05441 9.05933 8.04748 8.25146 8.04748 7.44435Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clockIcon.d761f1ae726646be7deabbf601d40799.svg";
export { ForwardRef as ReactComponent };